import { SceneData } from './SceneExporter';
import * as THREE from 'three';
import { GLTFExporter } from 'three/addons/exporters/GLTFExporter.js';
import { RepaintProgress } from '../Gui/components/panels/ProgressBar';

/**
 * Export3DGLTF.ts
 *
 * Goal:
 * - Export SceneData to glTF (GLB).
 *
 */

export async function Export3DGLTF(
    scenedata: SceneData,
    setProgress: (progress: number | undefined) => void
): Promise<{ formattedData: Uint8Array; extension?: string }> {
    console.log('Exporting scene to GLTF format');

    const exporter = new GLTFExporter();
    const sceneToExport: THREE.Scene = new THREE.Scene();
    sceneToExport.name = scenedata.geoDataName || 'ExportedScene';

    let progress = 0;
    const totalProgress = scenedata.layerMeshes.length;
    setProgress((progress / totalProgress) * 80 + 10);

    for (let i = 0; i < scenedata.layerMeshes.length; i++) {
        const group = new THREE.Group();
        group.name = scenedata.layerGroupNames[i] || `Group_${i}`;

        for (let root of scenedata.layerMeshes[i]) {
            const cloned = root.clone(true);
            cloned.updateMatrixWorld(true);
            group.add(cloned);
        }

        sceneToExport.add(group);

        progress++;
        setProgress((progress / totalProgress) * 80 + 10);
        await RepaintProgress();
    }

    sceneToExport.updateMatrixWorld(true);

    const options = {
        trs: false,
        onlyVisible: false,
        binary: true,
        maxTextureSize: 2048,
    };

    const exportedData: Uint8Array = await new Promise((resolve, reject) => {
        exporter.parse(
            sceneToExport,
            (result: any) => {
                if (result instanceof ArrayBuffer) {
                    // if export is binary (glb)
                    resolve(new Uint8Array(result));
                } else if (typeof result === 'object') {
                    // if export is text-based
                    resolve(new TextEncoder().encode(JSON.stringify(result)));
                } else {
                    reject(new Error('Unexpected GLTF format'));
                }
            },
            (error: unknown) => reject(error),
            options
        );
    });

    return { formattedData: exportedData, extension: 'glb' };
}
